import React from 'react';
import _ from 'lodash'

import { Inertia } from '@inertiajs/inertia';
import { InertiaLink } from '@inertiajs/inertia-react';

import {Form, Row, Col, Button} from "react-bootstrap"

import { toFormData, difference, upperFirst } from '@/utils';
import { PREFIX_NAME_MANAGER_ROUTING } from '@/constants/Site';

import BaseManager from '@/Shared/BaseManager';
import LoadingButton from '@/Shared/LoadingButton';
import FileInput from '@/Shared/inputs/FileInput';
import ListInput from '@/Shared/inputs/ListInput';
import DeleteButton from '@/Shared/DeleteButton';
import TrashedMessage from '@/Shared/TrashedMessage';
import {withPageProps} from '@/Shared/FuncComp';

class FormManager extends BaseManager {

	static statebase = {
		values: {},
		inputValues: {},
		sending: false,
		alterValues: new Set(),
	}
	
	state = {...FormManager.statebase,
		
	}
	
	cancelDefaultSendingFn = null;
	
	cancelarSending = () => {
		if (this.cancelDefaultSendingFn) this.cancelDefaultSendingFn();
	}
	
	defValues = (attrs=this) => {
		return (attrs.props.defValues && attrs.props.defValues(attrs))||{}
	}
	
	defValue = (path) => {
		const defValues = this.defValues();
		//console.log("values", values, "path", path, _.get(values, path));
		return _.get(defValues, path);
	}
	
	defInputValues = (attrs=this) => {
		//return this.attrs('$', 'inputValues', ['props'])||{}
		return (attrs.props.defInputs && attrs.props.defInputs(attrs))||{}
	}
	
	values = (path) => {
		const values = this.attrs('', 'values', ['props', 'state']);
		//console.log("values", values, "path", path, _.get(values, path));
		return path ? _.get(values, path) : values;
	}
	
	inputValues = (path) => {
		const inputValues = this.attrs('', 'inputValues', ['props', 'state']);
		return path ? _.get(inputValues, path) : inputValues;
	}

	alterValues = (path) => {
		const alterValues = this.attrs('', 'alterValues', ['props', 'state']);
		return path ? alterValues.has(path) : inputValues; 
	}
	
	getInitValues = (path, {defValues, defInputValues}={}) => {
		let initValues = this.attrs('', 'initValues', ['props', '']);
		if (typeof initValues == 'function') {
			initValues = initValues({manager: this, path, defInputValues, defValues});
		}
		return path ? _.get(initValues, path) : initValues; 
	}
	
	getInitInputs = (path, {defValues, defInputValues}={}) => {
		let initInputs = this.attrs('', 'initInputs', ['props', '']);
		if (typeof initInputs == 'function') {
			initInputs = initInputs({manager: this, path, defInputValues, defValues});
		}
		return path ? _.get(initInputs, path) : initInputs; 
	}
	
	setDefaults = (path, {cb}={}) => {
		const defValues = this.defValues(path)||{};
		// const defValues = {...this.getInitValues(path, {defValues})};
		Object.assign(defValues, this.getInitValues(path, {defValues})||{});
		const defInputValues = this.getInitInputs(path)||{};
		Object.assign(defInputValues, this.defInputValues(path, {defInputValues})||{});
		this.setValues({defValues, defInputValues}, {defaults: true, cb});
		/*if (!path) {
			this.setState({values:})
		} else {
		
		}*/
	}
	
	isChanged = ({values=this.state.values, defaults=this.defValues(), path}={}) => {
		if (path) {
			defaults = _.get(defaults, path);
			values = _.get(values, path);
		}
		return !_.isEqual(defaults, values);
	}
	
	cambios = (values=this.state.values, defaults=this.defValues()) => {
		return difference(values, defaults);
	}
	
	/*handleChangeFile = (name, file) => {
		const handler = this.attrs('', 
			'inputToVal.'+FormManager.routeValToHandler(name), 
			['props', ''] 
		);
		
		if (handler) handler(name, file);
		else {
			this.setValues({[name]: file})
		}
	}*/
	/**
	 * Saber si tiene la data de un item. Sirve para saber será un PUT method.
	 */
	hasEle = () => !!this.props.ele
	
	isWithFile = () => {
		if ('withFile' in this.state) return !!this.state.withFile;
		return !!this.props.withFile;
	}
	
	handleChange = (event, {type, val, item, input, name}={}) => { // TODO handle change
		const target = event?.target;
		if (!name) name = target?.name;
		if (!type) type = target?.type;
		const handler = this.attrs('', 
			'inputToVal.'+FormManager.routeValToHandler(name), 
			['props', ''] 
		);
		
		if (handler) {
			handler(event, {manager: this, type, name, input, val, item});
		} else {
			const options = {};
			let value;
			switch (type) {
				case 'checkbox':
				case 'switch':
					value = target.checked;
					break;
				case 'file':
					value = target.value ? target.files[0] : null; 
					event.stopPropagation();
					break;
					
				case 'list':
					value = {val, input};
					event.stopPropagation();
					break;
				default:
					//if (selectableList) value = {val: undefined, input: target.value};
					//else
						value = target.value;
					break;
			}
			/*const value = (type === 'checkbox'||type==="switch") ? 
				target.checked : target.value;*/
			// console.log(name, value, this.isMounted());
		   	this.setValues({[name]: value}/* , {cb: ()=>{
				   console.log(this.inputValues(), this.values());
			   }} */)
		}
	}
	
	setErrors = (errors, {update=true}={}) => { // TODO: Añadir que remueva el error state cuando un error prop cambie
		this.setState((prev)=>{
			if (typeof errors==="function") {
				errors = errors(prev.errors);
			}
			return {errors: update ? {...prev.errors, ...errors} : errors }
		});
	}

	errors = (path) => {
		const errors = {...this.props.errors, ...this.state.errors}
		return path ? errors[path] : errors;
	}
	
	//inputToVal
	
	//valToInput
	
	/*inputHandler = (key, {}) => {
		
	}*/
	
	static routeValToHandler = (route="") => {
		return route.split('.').map((name, idx)=>{
			let result;
			if ((/^\w?\d+$/g).test(name)) return '0'
			return !idx ? name : upperFirst(name);
		}).join('');
	}

	static inputComponent
	
	baseExtSetVals = () => {
		return this.props.valuesBaseRoute;
	}
	
	noStateCb = () => !!this.props.noStateCb
	
	isHookExtSetVals = () => !!this.props.hookSetVals
	
	hasExternalState = () => !!this.props.setStateVals
	
	static getDerivedStateFromProps(props, state) {
		const newState = {};
		if (props.values && !_.isEqual(props.values, state.values)) {
			newState.values = props.values;
		}
		if (props.inputValues && !_.isEqual(props.inputValues, state.inputValues)) {
			newState.inputValues = props.inputValues;
		}
		if (Object.keys(newState)!=0) return {...newState};
		return null;
	}
	
	setValues = (values={}, {cb, exactVals, base=this.baseExtSetVals(), defaults}={}) => {
		const updateState = {};
		if (!this.state.firstChange) {
			updateState.firstChange = true;
		}
		//const alterValues = 

		//const isCurrentHandlerState = !this.props.setStateVals;

		//const setState = this.props.setStateVals || this.setState

		const errors = {};
		
		let externalState = {};
		
		const handleValues = (prevState)=>{
			//let base = '';
			const valuesRoot = _.get(prevState, 'values', {});
			const inputValuesRoot = _.get(prevState, 'inputValues', {});
			const prevValues = valuesRoot;
			const prevInputValues = inputValuesRoot;
			const prevAlterValues = _.get(prevState, 'alterValues', new Set());
			const newValues = defaults ? values['defValues'] : {...prevValues};
			const newInputValues = defaults ? values['defInputValues'] : {...prevInputValues};
			let newAlterValues = defaults ? new Set() : undefined;
			
			if (typeof values === 'function') {
				//console.log(values, /*values({values: prevValues, input: prevInputValues})*/1);
				values = values({values: prevValues, input: prevInputValues})
			}
			
			if (!defaults) Object.keys(values).forEach((key)=>{
				const valor = values[key];
				const prevVal = _.get(prevValues, key);
				const baseKey = (base?base+".":"")+key;
				let val;
				if (valor && typeof valor==="object" && 'val' in valor && 'input' in valor) {
					val = valor['val'];
					_.set(newInputValues, key, valor['input'])
					exactVals = true;
				} else {
					val = valor;
				}
				if (!exactVals) {
					const converter = this.attrs('', 'valToInput.'+FormManager.routeValToHandler(key), ['props', ''])
					if (converter) {
						const input = converter(val, key);
						_.set(newInputValues, key, input);
					}
				}
				_.set(newValues, key, val);
				if (!_.isEqual(prevVal, val) && !prevAlterValues.has(key)) {
					if (!newAlterValues) {
						newAlterValues = new Set(prevAlterValues);
					}
					errors[baseKey] = undefined;
					newAlterValues.add(baseKey);
				}
			});
			const result = {alterValues: newAlterValues||prevAlterValues};
			
			result.inputValues = /*base ? _.set(inputValuesRoot, base, newInputValues) :*/ newInputValues;
			result.values = /*base ? _.set(valuesRoot, base, newValues) :*/ newValues;
			//if (true || !isCurrentHandlerState) {
				if (this.hasExternalState()) {
					/*if (base) {
						Object.keys(result).forEach(key=>{
							_.set(externalState, base, result[key]);
						})
					} else {
						externalState = result;
					}*/
					externalState = result;
				}
				externalState = result;
				return {...result, ...updateState}
			//}
			//return result;
		}

		const callback = () => {
			if (cb) cb();
			//this.setnewState
			if (this.hasExternalState()) this.props.setStateVals((p) => {
				if (this.isHookExtSetVals()) externalState = {...p, ...externalState}
				return externalState;
			})
		}

		/*if (isCurrentHandlerState)*/ this.setState(handleValues, callback) 
		this.setErrors(errors, {update: !defaults});
		/*if (!isCurrentHandlerState) {
			this.setState(updateState)
		}*/
	}
	
	hasFirstChange = () => !!this.state.firstChange
	
	componentDidUpdate (prevProps, prevState) {
		if (!_.isEqual(prevProps, this.props)) {
			const defaults = this.defValues({props: prevProps, state: prevState}); // añadir extra valores de la clase según sus nombres (props.extraDefValues: [])
			const values = this.values();
			if (!this.isChanged({values, defaults})) {
				
			}
		}
	}
	
	isMounted = () => !!this.mounted;
	
	// getInitValues = () => this.attrs('', 'initValues', ['props', '']);
	
	componentDidMount() {
		this.setDefaults();
		/*const initValues = this.getInitValues();
		if (initValues) Object.keys(initValues).forEach((key)=>{
			
		});*/
		this.mounted = true;
	}
	
	componentWillUnmount() {
		this.mounted = false;
	}
	
	canEdit = () => {
		if (typeof this.props.canEdit==='undefined') return true;
		return !!this.props.canEdit;
	}
	
	getMethod = () => {
		return this.props.method||(this.hasEle() && this.isResource() ? 'PUT' : "POST")
	}
	
	getRealMethod = (method=this.getMethod()) => {
		if (method && method.toUpperCase()!=='GET') {
	 		return "POST";
	 	} else {
	 		return 'GET';
	 	}
	}
	
	feedback = (name, props) => {
		const baseProps = {};
		if (!props.type) props.type='invalid';
		if (props?.type=='invalid') baseProps.children = this.errors(name);
		
		return <Form.Control.Feedback {...baseProps} {...props} />
	}
	
	/*onSelectItem = (name, value, inputValue) => {
		this.setValues({[name]: {val: value, input: inputValue}});
	}*/
	
	/*onChangeSelectableList = (e, opt) => {
		this.handleChange(e, {selectableList: true, ...opt})
	}*/
	
	control = (props, {individual=true, ...options}={}) => {
		const value = this.values(props.name)||"";
		const inputValue = this.inputValues(props.name);
		const baseProps = {isInvalid: !!this.errors(props.name)};
		const extras = {};
		const formMounted = this.isMounted()
		const alterValue = this.alterValues(props.name);
		let control;
		switch (props.type) {
			case 'checkbox':
			case 'switch':
				baseProps.custom = true;
				if (individual) {
					baseProps.id = (options.unique ? this.formCode + "-" : "") + props.name;
					return <Form.Check {...baseProps} checked={!!value}
						feedback={this.errors(props.name)}
						disabled={!this.canEdit()} id={props.name} 
						onChange={this.handleChange}
						{...props} 
					/>
				}
				break
			case 'radio':
			
				break;
			case 'list':
				
				//baseProps.onChange = this.onChangeSelectableList;
				baseProps.onChange = this.handleChange;
				baseProps.autoComplete = "off"
				
				extras.base = {...props.generalProps, alterValue, formMounted};
				delete props.generalProps;
				
				if (options.feedback && !props.feedback) { 
					extras.base.feedback = this.feedback(props.name, options.feedback)
				}
				
				delete props.type;
				
				extras.input = {...props, ...props.inputProps};
				delete extras.input.inputProps;
				
				extras.base.inputValue = inputValue;
				extras.base.value = value||undefined;
				
				extras.input={...baseProps, ...extras.input};
				return <Form.Control
					as={ListInput}
					onSelect={this.onSelectItem}
					//onChange={this.handleChange}
					{...extras.base} inputProps={extras.input}
				/>
				break;
			case 'file':
				baseProps.file = typeof inputValue!=='undefined' ? inputValue : value;
				if (options.group) baseProps.custom=true;
				if (options.feedback) baseProps.feedback = this.feedback(props.name, options.feedback);
				return <FileInput onChange={this.handleChange} {...baseProps} {...props} />
				break;
			default:
				baseProps.autoComplete = "off"
				baseProps.value = typeof inputValue!=='undefined' ? inputValue : value;
				
				//console.log("control value:", baseProps, inputValue, value)
				if (props.type=='range' || props.as=="select") {
					baseProps.custom = true;
				}
				/*if (props.type=='list') {
					baseProps.as = ListInput;
					if (options.feedback) { 
						baseProps.feedback = this.feedback(props.name, options.feedback)
						options.feedback = undefined;
					}
				}*/
				control = <Form.Control
					onChange={this.handleChange}
					{...baseProps} {...props}
				/>
				if (options.feedback) return <>
					{control}
					{this.feedback(props.name, options.feedback)}
				</>
				return control;
		}
	}
	
	label = (props) => {
		if (typeof props==="string") props = {children: props};
		return <Form.Label {...props} />
	}
	
	group = (props, label, input, options={}) => {
		if (!('feedback' in options)) options.feedback = {};
		if (typeof props=='string') props = {controlId: props};
		if (!input.name) input.name = props.controlId;
		options.group=true;
		return <Form.Group {...props}>
			{this.label(label)}
			{this.control(input, options)}
		</Form.Group>
	}
	
	rowDesc = (title, dsc, inner) => {
		if (typeof title === 'string') title = {children: title};
		if (typeof dsc === 'string') dsc = {children: dsc};
		return <Row>
			<Col lg={4}>
				<h4 {...title} />
				<p {...dsc} />
			</Col>
			<Col lg={8}>
				{inner}
			</Col>
		</Row>
	}
	
	validar = () => this.props.validator ? this.props.validator(this) : true;
	
	localValidator = () => typeof this.props.localValidator ? !!this.props.localValidator : false;
	
	prevSubmitBase = (cb) => {
		if (this.props.prevSubmit) this.props.prevSubmit(cb);
		else cb();
	}
	
	getSubmitBaseData = () => {
		return this.attrs('', 'submitBaseData');
	}
	
	submitData = () => {
		const baseData = {...this.getSubmitBaseData(), ...this.cambios()};
		const dataManager = this.attrs('$', 'submitDataResult');
		const data = dataManager ? {...dataManager(baseData, {values: this.values(), manager: this})} : baseData;
		const method = this.getMethod()?.toUpperCase();
		const csrf = this.getCsrf();
		if (method && (method!='POST' && method!='GET')) {
			data["_method"] = method;
		}
		if (csrf) {
			data["_token"] = csrf;
		}
		
		if (this.isWithFile()) return toFormData(data);
		
		return data;
	}
	
	getRouteStore = () => this.getRoute()+'.store';
	getRouteUpdate = () => this.getRoute()+'.update';

	href = () => {
		if (typeof this.props.href === "function") return this.props.href(this);
		return this.props.href||(
			this.hasRoute() ? (
				this.isResource() ? (
						this.hasEle()?
							route(this.getRouteUpdate(), this.getId()) : 
							route(this.getRouteStore(), this.hasRouteParent() ? this.getRouteParentId() : undefined)
				) : route(this.getRoute())
			) : undefined
		);
	}

	hrefString = () => (typeof this.href()==='object' ? this.href()?.name : this.href())||""
	
	submitBase = (e, {clickable}={}) => {
		e?.preventDefault();
		let validado = this.validar();
		if (validado || !this.withLocalValidator()) {
			if (this.isChanged()) this.prevSubmitBase(()=>{
				if (!this.state.sending) this.setState({sending: true});
				Inertia.post(this.href(), this.submitData(), {
					preserveScroll: true,
					onSuccess: (page) => {
						if (this.isMounted() && Object.keys(page.props.errors||{})==0) {
							this.setDefaults();
						}
						//console.log("success:", this.hrefString(), page)
						//return page;
					},
					onFinish: () => {
						if (this.isMounted()) {
							this.setState({sending: false, errors: {}});
						}
					},
					only: [...this.only()],
				});
			})
		} else {
			this.setState({verValidacion: true})
		}
	}
	
	submitHandler = (e, options) => {
		this.submitBase(e, options);
	}
	
	isRouteManager = () => {
		return !!this.attrs('', 'routeManager');
	}
	
	getRouteMain = () => this.props.route
	
	getRoutePrefix = () => this.attrs('', 'routePrefix')||
			(this.isRouteManager() ? PREFIX_NAME_MANAGER_ROUTING||'' : '')
	
	getRouteParent = () => {
		return this.props.routeParent;
	}
	
	hasRouteParent = () => !!this.props.routeParent;
	
	getRouteParentId = () => this.props.routeParentId;
		
	getRoute = () => {
		return this.getRoutePrefix()+(this.hasRouteParent()&&!this.getId()?
			this.getRouteParent()+".":""
		)+this.props.route
	}
	
	hasRoute = () => !!this.props.route;
	
	isResource = () => !!this.props.resource
	
	getId = () => this.props.ele && this.props.ele[this.getKey()];
	
	isDeleted = () => {
		return this.isResource() && !!this.props.ele?.deleted_at;
	}
	
	getDestroyData = () => {
		return this.attrs('', 'destroyData');
	}
	
	destroyNeedConfirm = () => !this.attrs('', 'dontConfirmDestroy')
	
	destroy = () => {
		if (this.hasRoute()) {
			Inertia.delete(route(this.getRoute()+'.destroy', this.getId()), {
				onBefore: () => (this.destroyNeedConfirm() ? confirm('¿Confirma que deseas remover el elemento?') : true),
				data: {...this.getDestroyData()},
				only: [...this.only()]
			});
		}
	}
	
	restore = () => {
		if (this.hasRoute()) {
			Inertia.put(route(this.getRoute()+'.restore', this.getId()), {
				onBefore: () => confirm('¿Confirma que deseas restaurar el elemento?'),
				only: [...this.only()]
			});
		}
	}

	isUpdating = () => !!this.props.ele
	
	DestroyBtn = React.forwardRef(({children, ...props}, ref) => {
		return <DeleteButton ref={ref} onDelete={this.destroy} {...props}>{children||"Borrar"}</DeleteButton>
	})
	
	only = () => this.props.only||[]

	getCsrf = () => this.attrs('$', 'csrf');
	
	Form = React.forwardRef(({children, withReset, footer, footerProps, className, defFooter, submitTxt, ...props}, ref) => {
		const {SubmitBtn, RestablecerButton, DestroyBtn} = this;
	 	const method = this.getMethod()?.toUpperCase();
	 	const realMethod = this.getRealMethod()?.toUpperCase();
	 	className = "form-manager pt-8"+(className?" "+className:"")
		return <Form method={realMethod} onSubmit={this.submitHandler} {...props} ref={ref} {...this.props.formProps} className={className}>
			{!!method && method!=='GET' && method!=='POST' && <Form.Control type="hidden" name="_method" value={method} />}
			{process.env.MIX_APP_ENV==='local' && false && <h5>href: {this.hrefString()} </h5>}
			{children}
			{(!!defFooter||footer) && <div {...footerProps} className={"px-8 py-4 bg-gray-100 border-t border-gray-200 flex items-center justify-end"+(footerProps?.className?" "+footerProps.className:"")}>
				{defFooter ? <>
					{this.isResource() && this.isUpdating() && 
						(this.isDeleted() ? (
						  <TrashedMessage onRestore={this.restore}>
							Restaurar elemento
						  </TrashedMessage>
						) :
						<DestroyBtn />)
					}
					{(this.isResource()||withReset) && this.isChanged() && <RestablecerButton className="mr-2" />}
					<SubmitBtn>
						{submitTxt||"Enviar"}
					</SubmitBtn>
				</> : footer}
			</div>}
		</Form>
	})
	
	isSending = () => {
		if (typeof this.props.sending !== "undefined") return !!this.props.sending;
		return !!this.state.sending;
	}
	
	RestablecerButton = React.forwardRef(({children, ...props}, ref) => {
		return <Button ref={ref} onClick={()=>this.setDefaults()} variant="secondary" {...props}>
			{children||'Restablecer'}
		</Button>
	})
	
	SubmitBtn = React.forwardRef(({clickable, ...props}, ref) => {
		return <LoadingButton type="submit" variant="primary" loading={this.isSending()} ref={ref} onClick={clickable?(e)=>{this.submitHandler(e, {clickable})}:undefined} {...props} />
	})
	
	renderBase = () => {
		const {component: Component, componentProps} = this.props;
		if (Component) return <Component key={"component-form-manager"} manager={this} {...componentProps} />
		return null;
	}
	
	render() {
		return this.renderBase();
	}
}

export default withPageProps(FormManager, {mapPageProps: (pageProps) => {
	return {errors: pageProps.errors}
}})
